import type { CSSProperties } from 'react';
import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type EqualProps = IconComponentBaseProps;

export const Equal = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: EqualProps) => {
  const maskId = useId();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={maskId} style={maskStyle} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M16.792 13.875C16.969 13.8751 17.1176 13.9349 17.2373 14.0547C17.357 14.1745 17.4169 14.3231 17.417 14.5C17.417 14.6771 17.357 14.8258 17.2373 14.9453C17.1176 15.065 16.969 15.1249 16.792 15.125H7.20801C7.03109 15.1249 6.88234 15.0651 6.7627 14.9453C6.643 14.8255 6.58305 14.6769 6.58301 14.5C6.58301 14.3229 6.64303 14.1742 6.7627 14.0547C6.88234 13.935 7.03109 13.8751 7.20801 13.875H16.792ZM16.792 8.875C16.969 8.87506 17.1176 8.93489 17.2373 9.05469C17.357 9.17448 17.4169 9.32308 17.417 9.5C17.417 9.6771 17.357 9.82577 17.2373 9.94531C17.1176 10.065 16.969 10.1249 16.792 10.125H7.20801C7.03109 10.1249 6.88234 10.0651 6.7627 9.94531C6.643 9.82553 6.58305 9.6769 6.58301 9.5C6.58301 9.32292 6.64303 9.17422 6.7627 9.05469C6.88234 8.93505 7.03109 8.87508 7.20801 8.875H16.792Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

const maskStyle: CSSProperties = { maskType: 'alpha' };
